<div class="relative bg-white dark:bg-azulOscuro p-4 mb-8 rounded-lg shadow-lg">
    <div class="flex items-center mb-6">
        <icon-arrow-backward class="cursor-pointer text-2xl text-primary hover:text-black dark:hover:text-white" (click)="goBackVehicle()"/>
        <button class="flex justify-between text-black dark:text-white cursor-pointer hover:text-primary dark:hover:text-primary" (click)="goBackVehicle()"> Volver</button>
    </div>

    <div class="grid grid-cols-1 gap-6">
        <!-- SOAT -->
        <div class="panel">
            <div class="mb-5">
                <h5 class="text-lg font-semibold text-black dark:text-white">SOAT</h5>
                <p class="text-gray-600 dark:text-gray-300">Garantiza atención médica inmediata y sin costo para las víctimas de un accidente.</p>
            </div>

            <div class="space-y-4">
                <div>
                    <label class="block text-sm font-medium text-gray-700 dark:text-gray-300">Fecha de Expiración</label>
                    <input 
                        type="date" 
                        [(ngModel)]="documentation.soatExpirationDate"
                        class="form-input mt-1"
                        [disabled]="!isEditing"
                    />
                </div>

                <div>
                    <label class="block text-sm font-medium text-gray-700 dark:text-gray-300">Evidencia del SOAT</label>
                    <div class="mt-1 flex items-center space-x-4">
                        <input 
                            type="file" 
                            accept="image/*"
                            (change)="onFileSelected($event, 'soat')"
                            class="hidden"
                            id="soatFile"
                            [disabled]="!isEditing"
                        />
                        <label 
                            for="soatFile" 
                            class="btn btn-outline-primary cursor-pointer"
                            [class.opacity-50]="!isEditing"
                        >
                            <icon-upload class="mr-2"></icon-upload>
                            Subir SOAT
                        </label>
                        <div *ngIf="documentation.soatEvidenceBase64" class="flex items-center">
                            <img 
                                [src]="documentation.soatEvidenceBase64" 
                                alt="SOAT" 
                                class="h-20 w-20 object-cover rounded"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Revisión Técnico-Mecánica -->
        <div class="panel">
            <div class="mb-5">
                <h5 class="text-lg font-semibold text-black dark:text-white">Revisión Técnico-Mecánica</h5>
                <p class="text-gray-600 dark:text-gray-300">Asegura que el vehículo esté en buen estado mecánico y cumple con las normas de seguridad vial.</p>
            </div>

            <div class="space-y-4">
                <div>
                    <label class="block text-sm font-medium text-gray-700 dark:text-gray-300">Fecha de Expiración</label>
                    <input 
                        type="date" 
                        [(ngModel)]="documentation.technicalReviewExpirationDate"
                        class="form-input mt-1"
                        [disabled]="!isEditing"
                    />
                </div>

                <div>
                    <label class="block text-sm font-medium text-gray-700 dark:text-gray-300">Evidencia de la Revisión</label>
                    <div class="mt-1 flex items-center space-x-4">
                        <input 
                            type="file" 
                            accept="image/*"
                            (change)="onFileSelected($event, 'technical')"
                            class="hidden"
                            id="technicalFile"
                            [disabled]="!isEditing"
                        />
                        <label 
                            for="technicalFile" 
                            class="btn btn-outline-primary cursor-pointer"
                            [class.opacity-50]="!isEditing"
                        >
                            <icon-upload class="mr-2"></icon-upload>
                            Subir Revisión
                        </label>
                        <div *ngIf="documentation.technicalReviewEvidenceBase64" class="flex items-center">
                            <img 
                                [src]="documentation.technicalReviewEvidenceBase64" 
                                alt="Revisión Técnica" 
                                class="h-20 w-20 object-cover rounded"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Próximo Cambio de Aceite -->
        <div class="panel">
            <div class="mb-5">
                <h5 class="text-lg font-semibold text-black dark:text-white">Próximo Cambio de Aceite</h5>
                <p class="text-gray-600 dark:text-gray-300">Kilometraje programado para el próximo cambio de aceite.</p>
            </div>

            <div>
                <label class="block text-sm font-medium text-gray-700 dark:text-gray-300">Kilometraje</label>
                <input 
                    type="number" 
                    [(ngModel)]="documentation.nextOilChangeKm"
                    class="form-input mt-1"
                    [disabled]="!isEditing"
                />
            </div>
        </div>

        <!-- Botones de Acción -->
        <div class="flex justify-end space-x-4">
            <button 
                *ngIf="!isEditing"
                class="btn btn-primary"
                (click)="isEditing = true"
            >
                <icon-pencil class="mr-2"></icon-pencil>
                Editar
            </button>
            <button 
                *ngIf="isEditing"
                class="btn btn-outline-danger"
                (click)="isEditing = false"
            >
                Cancelar
            </button>
            <button 
                *ngIf="isEditing"
                class="btn btn-primary"
                (click)="saveDocumentation()"
            >
                Guardar Cambios
            </button>
        </div>
    </div>
</div>
